import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { PythonExerciseComponent } from '../python-exercise/python-exercise';
import { getFormattedCode, SkyproDecodeHtmlService } from '@skyeng/libs/skypro/shared';

@Component({
  selector: 'skypro-python-result-message',
  template: '<ng-content></ng-content>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PythonResultMessageComponent implements AfterViewInit {
  private pythonExerciseComponent = inject(PythonExerciseComponent);
  private skyproDecodeHtmlService = inject(SkyproDecodeHtmlService);
  private elementRef = inject(ElementRef<HTMLElement>);

  ngAfterViewInit(): void {
    const resultMessage = this.skyproDecodeHtmlService.decodeHtml(getFormattedCode(this.elementRef.nativeElement));
    this.pythonExerciseComponent.addResultMessage(resultMessage);
  }
}
